// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3un-2","tab":"Tabs_tab__kMkil","tabActive":"Tabs_tabActive__14rMU"};